import React, { useEffect } from "react";
import { connect } from "react-redux";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Row, Button } from "react-bootstrap";
import "./style.scss";
import { dateFormater } from "../../utils/utilities";
import { Base } from "../../components/RootLayout";
import BwipJs from "bwip-js";
import { useNavigate } from "react-router-dom";

const ShowMyQrCode = (props) => {
  const navigate = useNavigate();
  const { profile } = props;

  useEffect(() => {
    try {
      // The return value is the canvas element
      let canvas = BwipJs.toCanvas("qr_code", {
        bcid: "qrcode",
        text: profile.membership_qrkey,
        scale: 3,
        height: 30,
        width: 30,
        includetext: true,
        textxalign: "center",
      });
    } catch (e) {
      // `e` may be a string or Error object
    }
  }, []);
  return (
    <Base>
      <TopNavigation
        titlePage="My QR Code"
        toPath={PageRoutes.account}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <br />
      <center>
        <canvas id="qr_code"></canvas>
        {/* <QRCodeSVG value={profile.membership_qrkey} size="240px" /> */}
      </center>
      <br />
      <div style={{ textAlign: "center" }}>
        <p>{`${profile.first_name} ${profile.last_name}`}</p>
        <p>{profile.membership_num}</p>
        <p>{`Member since ${dateFormater(profile.date_employed)}`}</p>
      </div>
      <Row className="grouping-btn">
        <Button className="border-0" onClick={() => navigate(PageRoutes.home)}>
          Check My Points
        </Button>
        <Button
          className="border-0"
          onClick={() => navigate(PageRoutes.reward)}
        >
          Redeem My Reward
        </Button>
      </Row>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.ProfileSM.profile,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMyQrCode);
